import createReadonlyDictionary from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";

const ActiveProgramDictionary = createReadonlyDictionary({
  fetch: async function() {
    return await api.get(`/active-program/list`);
  },
});

export default ActiveProgramDictionary.create();
